import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import routes from '../routes/route';
import viewDeploymentOrganizations from './viewRelatedDeploymentOrganizations';

export default {
  attributeName: 'liveDeployments',
  isDragable: false,
  canOpen: false,
  canEdit: true,
  canCreate: true,
  canRemove: true,
  
  emptyMessage: "You don't have live deployments items, click on the \"+\" icon to create one.",
  fields: [
    {
      attributeName: 'code',
      label: 'Code',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The name of the deployment. It must be without spaces and special characters. It must be unique per app.',
      default: '',
      canEdit: false,
      canCreate: true,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'cloudType',
      label: 'Cloud',
      type: FormInputTypes.SELECT,
      default: [1],
      width: '8rem',
      options: [
        {value:"-1",name:"(Select an option)"},
        {value:"AWS",name:"AWS"},
        {value:"GCP",name:"GCP"},
      ],
      canOrder: true,
      canEdit: false,
      canFilter: true,
      canCreate: true,
      helpText: 'Type of AWS Region for deployment.',
    },
    {
      attributeName: 'region',
      label: 'Region',
      type: FormInputTypes.SELECT,
      default: [1],
      width: '18rem',
      options: [
        {value:"-1",name:"(Select an option)"},
        {value:"AF-SOUTH-1",name:"AWS AF-SOUTH-1 - Africa (Cape Town)"},
        {value:"AP-EAST-1",name:"AWS AP-EAST-1 - Asia Pacific (Hong Kong) "},
        {value:"AP-NORTHEAST-1",name:"AWS AP-NORTHEAST-1 - Asia Pacific (Tokyo)"},
        {value:"AP-NORTHEAST-2",name:"AWS AP-NORTHEAST-2 - Asia Pacific (Seoul)"},
        {value:"AP-NORTHEAST-3",name:"AWS AP-NORTHEAST-3 - Asia Pacific (Osaka)"},
        {value:"AP-SOUTH-1",name:"AWS AP-SOUTH-1 - Asia Pacific (Mumbai)"},
        {value:"AP-SOUTHEAST-1",name:"AWS AP-SOUTHEAST-1 - Asia Pacific (Singapore)"},
        {value:"AP-SOUTHEAST-2",name:"AWS AP-SOUTHEAST-2 - Asia Pacific (Sydney)"},
        {value:"AP-SOUTHEAST-3",name:"AWS AP-SOUTHEAST-3 -  Asia Pacific (Jakarta)"},
        {value:"CA-CENTRAL-1",name:"AWS CA-CENTRAL-1 - Canada (Central)"},
        {value:"EU-CENTRAL-1",name:"AWS EU-CENTRAL-1 - Europe (Frankfurt)"},
        {value:"EU-NORTH-1",name:"AWS EU-NORTH-1 - Europe (Stockholm)"},
        {value:"EU-SOUTH-1",name:"AWS EU-SOUTH-1 - Europe (Milan)"},
        {value:"EU-WEST-1",name:"AWS EU-WEST-1 - Europe (Ireland)"},
        {value:"EU-WEST-2",name:"AWS EU-WEST-2 - Europe (London)"},
        {value:"EU-WEST-3",name:"AWS EU-WEST-3 - Europe (Paris)"},
        {value:"ME-SOUTH-1",name:"AWS ME-SOUTH-1 - Middle East (Bahrain)"},
        {value:"SA-EAST-1",name:"AWS SA-EAST-1 - South America (São Paulo)"},
        {value:"US-EAST-1",name:"AWS US-EAST-1 - US East (N. Virginia)"},
        {value:"US-EAST-2",name:"AWS US-EAST-2 - US East (Ohio)"},
        {value:"US-WEST-1",name:"AWS US-WEST-1 - US West (N. California)"},
        {value:"US-WEST-2",name:"AWS US-WEST-2 - US West (Oregon)"},
        {value:"asia-east1-a",name:"GCP asia-east1-a - Asia Pacific (Taiwan)"},
        {value:"asia-east1-b",name:"GCP asia-east1-b - Asia Pacific (Taiwan)"},
        {value:"asia-east1-c",name:"GCP asia-east1-c - Asia Pacific (Taiwan)"},
        {value:"asia-east2-a",name:"GCP asia-east2-a - Asia Pacific (Hong Kong)"},
        {value:"asia-east2-c",name:"GCP asia-east2-c - Asia Pacific (Hong Kong)"},
        {value:"asia-northeast1-a",name:"GCP asia-northeast1-a - Asia Pacific (Japan)"},
        {value:"asia-northeast1-c",name:"GCP asia-northeast1-c - Asia Pacific (Japan)"},
        {value:"asia-northeast3-a",name:"GCP asia-northeast3-a - Asia Pacific (South Korea)"},
        {value:"asia-northeast3-b",name:"GCP asia-northeast3-b - Asia Pacific (South Korea)"},
        {value:"asia-northeast3-c",name:"GCP asia-northeast3-c - Asia Pacific (South Korea)"},
        {value:"asia-south1-a",name:"GCP asia-south1-a - Asia Pacific (India)"},
        {value:"asia-south1-b",name:"GCP asia-south1-b - Asia Pacific (India)"},
        {value:"asia-southeast1-a",name:"GCP asia-southeast1-a - Asia Pacific (Singapur)"},
        {value:"asia-southeast1-b",name:"GCP asia-southeast1-b - Asia Pacific (Singapur)"},
        {value:"asia-southeast1-c",name:"GCP asia-southeast1-c - Asia Pacific (Singapur)"},
        {value:"australia-southeast1-a",name:"GCP australia-southeast1-a - Asia Pacific (Australia)"},
        {value:"australia-southeast1-b",name:"GCP australia-southeast1-b - Asia Pacific (Australia)"},
        {value:"australia-southeast1-c",name:"GCP australia-southeast1-c - Asia Pacific (Australia)"},
        {value:"europe-west1-b",name:"GCP europe-west1-b - Europe (Belgium)"},
        {value:"europe-west1-c",name:"GCP europe-west1-c - Europe (Belgium)"},
        {value:"europe-west1-d",name:"GCP europe-west1-d - Europe (Belgium)"},
        {value:"europe-west2-a",name:"GCP europe-west2-a - Europe (England)"},
        {value:"europe-west2-b",name:"GCP europe-west2-b - Europe (England)"},

        {value:"europe-west3-a",name:"GCP europe-west3-a - Europe (Germany)"},
        {value:"europe-west3-b",name:"GCP europe-west3-b - Europe (Germany)"},
        {value:"europe-west3-c",name:"GCP europe-west3-c - Europe (Germany)"},

        {value:"europe-west4-a",name:"GCP europe-west4-a - Europe (Netherlands)"},
        {value:"europe-west4-b",name:"GCP europe-west4-b - Europe (Netherlands)"},
        {value:"europe-west4-c",name:"GCP europe-west4-c - Europe (Netherlands)"},
        {value:"northamerica-northeast1-a",name:"GCP northamerica-northeast1-a - North America (Canada)"},
        {value:"northamerica-northeast1-b",name:"GCP northamerica-northeast1-b - North America (Canada)"},
        {value:"northamerica-northeast1-c",name:"GCP northamerica-northeast1-c - North America (Canada)"},
        {value:"southamerica-east1-c",name:"GCP southamerica-east1-c - South America (Brazil)"},
        {value:"southamerica-west1-a",name:"GCP southamerica-west1-a - South America (Chile)"},
        {value:"southamerica-west1-b",name:"GCP southamerica-west1-b - South America (Chile)"},
        {value:"southamerica-west1-c",name:"GCP southamerica-west1-c - South America (Chile)"},
        {value:"us-central1-a",name:"GCP us-central1-a - US Central (Iowa)"},
        {value:"us-central1-b",name:"GCP us-central1-b - US Central (Iowa)"},
        {value:"us-central1-c",name:"GCP us-central1-c - US Central (Iowa)"},
        {value:"us-central1-f",name:"GCP us-central1-f - US Central (Iowa)"},
        {value:"us-east1-b",name:"GCP us-east1-b - US East (South Carolina)"},
        {value:"us-east1-c",name:"GCP us-east1-c - US East (South Carolina)"},
        {value:"us-east1-d",name:"GCP us-east1-d - US East (South Carolina)"},
        {value:"us-east4-a",name:"GCP us-east4-a - US East (Virginia)"},
        {value:"us-east4-b",name:"GCP us-east4-b - US East (Virginia)"},
        {value:"us-east4-c",name:"GCP us-east4-c - US East (Virginia)"},
        {value:"us-west1-a",name:"GCP us-west1-a - US West (Oregon)"},
        {value:"us-west1-b",name:"GCP us-west1-b - US West (Oregon)"},
        {value:"us-west2-b",name:"GCP us-west2-b - US West (California)"},
        {value:"us-west2-c",name:"GCP us-west2-c - US West (California)"},
        {value:"us-west4-a",name:"GCP us-west4-a - US West (Nevada)"},
        {value:"us-west4-b",name:"GCP us-west4-b - US West (Nevada)"},
      ],
      canOrder: true,
      canEdit: false,
      canFilter: true,
      canCreate: true,
      helpText: 'Type of AWS Region for deployment.',
    },
    {
      attributeName: 'projectId',
      label: 'GCP Project ID',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      helpText: 'The GGP project Id to identify the deployment inside the cloud.',
      default: '',
      canEdit: false,
      canCreate: true,
      canFilter: true,
      canOrder: true,
    },
    {
      attributeName: 'backendAgentMode',
      label: 'Agent Mode',
      type: FormInputTypes.CHECKBOX,
      canEdit: true,
      canOrder: false,
      canCreate: true,
      helpText: 'If true Agents in cloud else local agents.',
      width: '8rem',
      default: false,
      refreshRowOnChange:true
    },
    {
      attributeName: 'lbStatus',
      label: 'LB Status',
      helpText: 'Status of Live Backend Load Balancer.',
      type: FormInputTypes.STATUS,
      valueButton:['lb_success','lb_pending'],
      buttonText:'refresh',
      textAreYouSure:'Are you sure you want to try to obtain the load balancer?',
      actionUrl:'livedeploymentsLoadBalancerRefresh',
      secondaryValue: 'liveBackendEndPointLog',
      width: '10rem',
      canOrder: true,
      colors: {
        lb_pending: 'bg-danger',
        lb_success: 'bg-success',
        lb_not_used: 'bg-disabled'
      },
      refreshRowOnChange:true
      // visibleWhen:{"field":"backendAgentMode","value":true},
    },

    {
      attributeName: 'timeshift',
      label: 'Timeshift',
      type: FormInputTypes.CHECKBOX,
      canEdit: true,
      canOrder: false,
      canCreate: true,
      helpText: 'Check if the deployment allow timeshift for live events.',
      width: '8rem',
      default: false,
      enabledWhen:{"field":"deploymentType","values":['ott']},
      refreshRowOnChange:true
    },
    {
      attributeName: 'gpu',
      label: 'Is GPU',
      type: FormInputTypes.CHECKBOX,
      canEdit: true,
      canOrder: false,
      canCreate: true,
      helpText: 'If the deployment is GPU based.',
      width: '8rem',
      default: false,
      enabledWhen:{"field":"deploymentType","values":['ott']},
      refreshRowOnChange:true
    },
    {
      attributeName: 'hls',
      label: 'HLS',
      type: FormInputTypes.CHECKBOX,
      canEdit: true,
      canOrder: false,
      canCreate: true,
      helpText: 'If the deployment has HLS.',
      width: '8rem',
      default: false,
      enabledWhen:{"field":"deploymentType","values":['ott']},
      refreshRowOnChange:true    
    },
    {
      attributeName: 'deploymentType',
      label: 'Type',
      type: FormInputTypes.SELECT,
      default: [0],
      width: '10rem',
      options: [
        {value:"-1",name:"(Select an option)"},
        {value:"ott",name:"OTT"},
        {value:"lowLatency",name:"Low Latency"},
      ],
      canOrder: true,
      canEdit: false,
      canFilter: true,
      canCreate: true,
      helpText: 'Type of AWS Region for deployment.',
    },
    {
      attributeName: 'status',
      label: 'Status',
      helpText: 'Status of Live Deployment.',
      type: FormInputTypes.STATUS,
      valueButton:'in_use',
      buttonText:'release',
      textAreYouSure:'Are you sure you want to release the deployment?',
      actionUrl:'livedeploymentsrelease',
      secondaryValue: 'log',
      width: '10rem',
      canOrder: true,
      colors: {
        in_use: 'bg-danger',
        free: 'bg-success',
        offline: 'bg-disabled',
        error:'bg-disabled'
      },
    },
    /*{
      attributeName: 'organizations',
      label: 'Organizations',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      canFilter: false,
      configFile: viewDeploymentOrganizations,
      default: [],
      helpText: 'Organizations that can access to this deployment.',
    },*/
    {
      attributeName: 'status_data',
      label: 'More',
      width: '4rem',
      helpText: 'More information about the in-use live deployment.',
      type: FormInputTypes.MORE,
    },
  ],
};


